module.exports = __webpack_public_path__ + "img/list.d2d9819d.svg";